import { createApp } from 'vue'
import { createPinia } from 'pinia'
import AOS from 'aos'
import 'aos/dist/aos.css'

import App from './App.vue'
import router from './router'
import { i18n } from '@/tools'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(i18n)
// 全局错误处理
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue 捕获到的错误:', err)
  console.error('组件实例:', vm)
  console.error('错误信息:', info)
  // 这里可以根据需求处理错误，例如记录日志、提示用户等
}
// 捕获同步错误
window.onerror = (message, source, lineno, colno, error) => {
  console.error('全局错误:', { message, source, lineno, colno, error })
}

// 捕获 Promise 中的未处理错误
window.addEventListener('unhandledrejection', event => {
  console.error('未处理的 Promise 错误:', event.reason)
})

try {
  app.mount('#app')
} catch (error) {
  console.error(error)
  if (error.message.includes('nextSibling')) {
    window.reload()
  }
}

AOS.init({
  duration: 1000,
  offset: 100,
  once: false,
})
